import type { TableFilterOperator } from '@ipfabric/utils';

const operators: { [Key in TableFilterOperator]: string } = {
  emptyTrue: 'is empty',
  emptyFalse: 'is not empty',
  eq: 'equal',
  neq: 'not equal',
  ieq: 'insensitive equal',
  nieq: 'insensitive not equal',
  lt: '<',
  lte: '<=',
  gt: '>',
  gte: '>=',
  like: 'contains',
  notlike: 'not contains',
  reg: 'regex',
  nreg: 'not equal regex',
  ireg: 'insensitive regex',
  nireg: 'insensitive not equal regex',
  cidr: 'CIDR range',
  sect: 'overlaps',
  nsect: 'not overlaps',
  ip: 'contains IP address',
  column: 'equal column',
  ncolumn: 'not equal column',
  nowGt: 'is more than',
  nowLt: 'is less than',
  color: 'has color',
  containsAny: 'includes',
  containsAll: 'includes all',
  notContainsAny: 'excludes',
  'name containsAny': 'includes group',
  'name notContainsAny': 'excludes group',
};

export const advancedFilterMessages = {
  en: {
    arrayOperators: {
      any: 'any item',
      all: 'all items',
    },
    operators,
    dateTimeNowPostfixMessage: 'days from today',
    contextMenu: {
      copy: 'Copy group',
      pasteGroup: 'Paste as a subgroup',
      pasteRules: 'Paste as appended rules',
      pasteAndReplace: 'Paste and replace',
      deleteGroup: 'Delete group',
    },
    actions: {
      addGroup: 'Add group',
      addRule: 'Add rule',
    },
    preview: 'Preview',
  },
};
